import { render, staticRenderFns } from "./nieuws.vue?vue&type=template&id=423552b2&scoped=true&"
import script from "./nieuws.vue?vue&type=script&lang=js&"
export * from "./nieuws.vue?vue&type=script&lang=js&"
import style0 from "./nieuws.vue?vue&type=style&index=0&id=423552b2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423552b2",
  null
  
)

export default component.exports